'use client';

import { Icon } from '@iconify/react';
import type { ModuleCardProps } from './props';

export function ModuleCard({ module: mod, isReadOnly, onToggle }: ModuleCardProps) {
    const interactive = !isReadOnly && !mod.locked;

    return (
        <div
            className={`group relative rounded-lg border p-3 transition-all duration-150 ${
                mod.enabled
                    ? 'border-mfour-green/40 bg-mfour-green/5'
                    : 'border-default-200 bg-transparent'
            } ${interactive ? 'cursor-pointer hover:border-mfour-green/60 hover:shadow-sm' : ''}`}
            onClick={() => interactive && onToggle(mod.id)}
            role={interactive ? 'button' : undefined}
            tabIndex={interactive ? 0 : undefined}
            onKeyDown={(e) => {
                if (interactive && (e.key === 'Enter' || e.key === ' ')) {
                    e.preventDefault();
                    onToggle(mod.id);
                }
            }}
        >
            <div className="flex items-start gap-2.5">
                <div
                    className={`mt-0.5 flex h-4 w-4 flex-shrink-0 items-center justify-center rounded transition-colors ${
                        mod.enabled
                            ? 'bg-mfour-green text-white'
                            : 'border border-default-300 bg-transparent'
                    }`}
                >
                    {mod.enabled && <Icon icon="lucide:check" width={10} />}
                </div>
                <div className="min-w-0 flex-1 overflow-hidden">
                    <p className="break-words text-small font-medium leading-5 text-foreground">
                        {mod.name}
                    </p>
                    <p className="mt-0.5 break-words text-tiny leading-4 text-default-400">
                        {mod.description}
                    </p>
                </div>
            </div>
        </div>
    );
}
